<template>
    <div class="help">
        <div class="content">
            <Component :is="display_modal_name" @closeModal="closeModal"></Component>
        </div>
        <div class="modal_close" @click="closeModal">
            <span class="round_btn"></span>
        </div>
        <modal-on-modal :class="{active: show_mom}" @resolve="mom_reply[0]" @reject="mom_reply[1]" />
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    const compoPathList = [
        './SelectItem.vue',
        './AddItem.vue',
        './ChangeStyle.vue',
        './SelectScene.vue',
        './SelectProducts.vue',
        './SelectSlatCategory.vue',
        './CheckItem.vue',
        './BrowseSlatByCtg.vue',
        './SelectPartsColor.vue',
        './BrowseTapeColor.vue',
        './SelectWallColor.vue',
        './ComfirmReset.vue',
        './BrowsePartsList.vue',
        './parts/ModalOnModal.vue'
    ]

    export default {
        name: "ModalContent",
        components: compoPathList.reduce((cmp, compoPath) => {
            const [basename] = compoPath.split('/').slice(-1)
            const name = basename.replace(/\.vue$/, '')
            return {
                ...cmp,
                /* passing var compoPath to import() directly raises error ...WTF? */
                [name]: () => import(`${compoPath}`)
            }
        }, {}),
        computed: {
            ...mapState(["display_modal_name", "show_mom", "mom_reply"])
        },
        methods: {
            closeModal() { this.$emit('close') }
        },

    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/define";

    p{margin: 0}

    .help{
        display: flex;
        justify-content: center;
        position: relative;
        width: calc(100% - 50px);
        height: calc(100% - 50px);
        margin: auto;
        padding: calc(12 / 349 * 100%);
        box-sizing: border-box;
        max-width: 1042px;
        border:1px solid #040404;
        background-color: rgba(255,255,255,0.8);
        .content{
            position: relative;
            width: 100%;
            overflow-y: auto;

        }
        .modal_close {
            position: absolute;
            right: -10px;
            top: -10px;
            z-index: 10;
            cursor: pointer;
            .round_btn {
                display: block;
                position: relative;
                width: 30px;
                height: 30px;
                border: 2px solid #343434; /* 枠の調整 */
                border-radius: 50%; /* 丸みの度合い */
                background: #fff; /* ボタンの背景色 */
                transition: 0.5s;
            }
            .round_btn::before, .round_btn::after {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                width: 3px; /* 棒の幅（太さ） */
                height: 22px; /* 棒の高さ */
                background: #343434; /* バツ印の色 */
            }
            .round_btn::before {
                transform: translate(-50%, -50%) rotate(45deg);
            }
            .round_btn::after {
                transform: translate(-50%, -50%) rotate(-45deg);
            }
            .round_btn:hover {
                background: #343434;
            }
            .round_btn:hover::before, .round_btn:hover::after {
                background: #fff;
            }
        }

    }
    @media (max-width: 739px) {
        .help {
            width: calc(100% - 30px);
            height: calc(100% - 20px);
            padding: 10px;
            .modal_close {
                right: -8px;
                top: -8px;
                .round_btn {
                    width: 20px;
                    height: 20px;
                }
                .round_btn::before, .round_btn::after {
                    width: 3px; /* 棒の幅（太さ） */
                    height: 15px; /* 棒の高さ */
                }
            }

        }
        }

</style>
